import React from 'react'
import TableLayout from '../../components/TableLayout'

const SatCodeListContainer = () => {
    const columns = [
        {
            title: 'Clave',
            dataIndex: 'code',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de codigo sat"
                columns={columns}
                resource="sat_code"
                actions={['active', 'create', 'edit', 'show']}
            />
        </>
    )
}

export default SatCodeListContainer
